import { getApis } from 'library/Apis';
import { EscolaDTO } from 'models/escola';
import { toRequest } from 'utils/RequestUtils';

const getEndpoint = (version: number, path = '/escola') => {
  return `${getApis().apis.bff}v${version}${path}`;
};

export const getEscolasOptions = (necessaria?: number | null) => {
  const url = getEndpoint(1);
  return toRequest<EscolaDTO[]>('post', [
    url,
    necessaria ? [necessaria] : [],
  ]);
};
